import { gql } from '@apollo/client'
import { pathOr } from 'ramda'

import { generalClient } from '../../../../utils/apollo/api'
import { usePromiseQuery } from '../../../../utils/apollo/_helpers/promiseQuery'

const QUERY = gql`
  query ScreenViews($search: String, $page: Int, $filter: ScreenViewFilter) {
    screenViews(search: $search, page: $page, filter: $filter, sort: { field: NAME, type: ASC }) {
      id
      name
      filters
    }
  }
`

export const useScreenViewsLoader = filter => {
  const query = usePromiseQuery(QUERY, { client: generalClient })
  return (search, page = 1) => {
    return query({ search, page, filter })?.then(pathOr([], ['data', 'screenViews']))
  }
}
